import * as React from 'react';
import translate from '../../../../locale/translate';

import { CheckboxInput } from '../../common/Input';
import { NodeTagFilterEditor, NodeSystemFilterEditor } from '../../common/Editor';
import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';

import { getDisplayValue, formatDate } from '../../util/StringUtil';

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler
}

const FORMATS = [
    'L',
    'LL',
    'LLL',
    'L LTS',
];

export default class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    handleSelect(evt: React.ChangeEvent<HTMLSelectElement>) {
        this.props.handleChange(evt.target.name, evt.target.value);
    }

    render() {
        const { settings, handleChange } = this.props;
        const now = new Date();

        return (
            <div>
                <h3>{translate.gettext("Filter")}</h3>

                <NodeSystemFilterEditor {...this.props} />
                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext("Display")}</h3>
                <CheckboxInput
                    label={translate.gettext("Sensors and systems without alerts")}
                    name="displayWithoutAlerts"
                    checked={settings.displayWithoutAlerts}
                    onChange={this.handleChange.bind(this)} />

                <div className="form-group">
                    <label>{translate.gettext("Date format")}</label>
                    <select name="dateFormat" className="form-control" value={settings.dateFormat} onChange={this.handleSelect.bind(this)} >
                        {FORMATS.map(format => {
                            return <option key={format} value={format}>{formatDate(now, format)}</option>
                        })}
                    </select>
                </div>

                <CheckboxInput
                    label={translate.gettext("Public hints on alerts")}
                    name="displayHints"
                    checked={settings.displayHints}
                    onChange={this.handleChange.bind(this)} />

                <h3>{translate.gettext('Columns')}</h3>
                <CheckboxInput
                    label={translate.gettext("First reported")}
                    name="displayDate"
                    checked={settings.displayDate}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext("Last reported")}
                    name="displayLastDate"
                    checked={settings.displayLastDate}
                    onChange={this.handleChange.bind(this)} />
                
                <CheckboxInput
                    label={translate.gettext("Outdated")}
                    name="displayResolved"
                    checked={settings.displayResolved}
                    onChange={this.handleChange.bind(this)} />

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/alerts/listAlerts/Editor.tsx